import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import {
  AlignItems,
  Box,
  Color,
  Display,
  Heading2,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import { useSearchArticles } from '../../hooks'
import { SearchHero } from '../SearchHero'
import { SearchResultArticles } from '../SearchResultArticles'
import { ContentLoader } from '../ContentLoader'
import { NoSearchResult } from '../NoSearchResult'
import { SearchFAQ } from '../SearchFAQ'

export const Search = () => {
  const { search } = useLocation()
  const query = new URLSearchParams(search).get('query')
  const { isLoading, searchResult } = useSearchArticles(query || '')

  const searchResultMessage = query?.length ? `Results for "${query}"` : 'Most popular articles'
  const result = useMemo(() => {
    if (searchResult?.results) {
      if (searchResult.results.length > 0) {
        return <SearchResultArticles searchResult={searchResult} isFullResult query={query || ''} />
      } else {
        return <NoSearchResult isStandalone query={query || ''} />
      }
    } else {
      return <SearchFAQ query={query || ''} />
    }
  }, [query, searchResult])

  return (
    <>
      <SearchHero searchInitValue={query || ''} />
      <Box
        paddingH={[3, 6]}
        paddingV={[5, 10]}
        bg={Color.NeutralGrey_50}
      >
        {
          isLoading
            ? (
              <Box
                display={Display.Flex}
                alignItems={AlignItems.Center}
                justifyContent={JustifyContent.Center}
              >
                <ContentLoader />
              </Box>
            )
            : (
              <>
                <Heading2 size={5}>{searchResultMessage}</Heading2>
                <Space size={8} />
                {result}
              </>
            )
        }
      </Box>
    </>
  )
}
